import AWS from 'aws-sdk';

const S3_BUCKET = process.env.NEXT_PUBLIC_DO_SPACE_BUCKET_NAME;
// const REGION = 'ap-south-1';

const spacesEndpoint = new AWS.Endpoint('sgp1.digitaloceanspaces.com');

// AWS.config.update({
//     accessKeyId: 'AKIATIIIIE2PSDNTLMW3',
//     secretAccessKey: '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'
// })

// const myBucket = new AWS.S3({
//     params: { Bucket: S3_BUCKET },
//     region: REGION,
// })

const myBucket = new AWS.S3({
  endpoint: spacesEndpoint,
  accessKeyId: process.env.NEXT_PUBLIC_DO_SPACES_ACCESS_KEY_ID,
  secretAccessKey: process.env.NEXT_PUBLIC_DO_SPACES_SECRET_ACCESS_KEY,
});

export const uploadFile = async (profileImage, folderName) => {
  if (profileImage?.name) {
    const params = {
      ACL: 'public-read',
      Body: profileImage,
      Bucket: S3_BUCKET,
      ContentType: profileImage.type,
      Key: folderName
        ? folderName + Date.now() + '_' + profileImage.name.replaceAll('_', '-')
        : Date.now() + '_' + profileImage.name.replaceAll('_', '-'),
    };
    const response = myBucket
      .putObject(params)
      // .on('httpUploadProgress', (evt) => {
      //     // console.log("evt")
      // })
      .send((err) => {
        if (err) console.log('errUpload', err);
      });
    const commonUrl = response.request.httpRequest;
    const url =
      commonUrl.endpoint.protocol +
      '//' +
      commonUrl.endpoint.hostname +
      commonUrl.path;
    return url;
  }
};
